module.exports = __webpack_public_path__ + "static/media/SB.3d7df2bb.png";